<template>
  <div class="back">
    <el-container class="containerClass"> 
      <el-main>
          <el-row type="flex" style="align-items:center;height:100vh;" justify="center">  
            <router-link to="/final/ReplaceBattery"> 
              <el-button type="success" style="width:30vw;font-size:5vw;height:20vh;color:rgb(24, 23, 23)"> 
                    换教程
              </el-button> 
            </router-link> 
            <div style="width:7vw;"></div>
            <router-link to="/Charge/ChargeShow"> 
              <el-button type="success" style="width:30vw;font-size:5vw;height:20vh;color:rgb(32, 31, 31)"> 
                    充电教程
              </el-button> 
            </router-link> 

          </el-row>  
      </el-main>
      <div class="divClass" @click="goFn()">粤ICP备15052018号-2</div>

    </el-container> 
  </div>
</template>
 
<script scoped>
  export default {
      name:"login",
      methods:{
        goFn(){
          window.open("https://beian.miit.gov.cn/")
        },
      },
  }
</script>

<style scoped>
.back{
    background: url('../assets/login.jpg'); 
    background-size: 100% 100%;
    background-attachment:fixed;
    height:100vh;
     /* color:rgb(32, 31, 31)  */
}
.el-card__body, .el-main {
    padding: 0px;
}
.containerClass{
  position: relative;
}
.divClass{
  position:absolute;
  bottom: 10%;
  left: 46%;
  cursor: pointer;
}
</style>